import React from "react";
import OurAgentsComponent from "../components/OurAgents/OurAgentsComponent";

import "../assets/styles/ouragents.scss";
import "aos/dist/aos.css";

const OurAgents = (props) => {
  return (
    <section>
      <OurAgentsComponent />
    </section>
  );
};

export default OurAgents;
